export function capitalize(string, separator = " ") {
    if (typeof string !== "string") {
        return string;
    }

    string = string.trim();

    if (!string) {
        return string;
    }

    const words = string.split(separator);

    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substring(1);
    }

    return words.join(" ");
}

export function snakeCaseToSpace(string) {
    return string.replaceAll("_", " ");
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
